import { getCurrentDevice } from './utils';

const handleNavigationDropdown = () => {
	const $trigger = $('.js-nav-dropdown-trigger');
	const $back = $('.js-nav-dropdown-back');
	const $scrollholder = $('.modal-navigation__dialog');

	$trigger.on('click', function(e){
		e.preventDefault();

		$(this).next().addClass('active');

		if($(this).hasClass('custom-toggle')){
			$(this).attr('aria-expanded', 'true');
		}

		if ( getCurrentDevice() == 'mobile' ) {
			$scrollholder.animate({
				scrollTop: 0
			}, 200);

			setTimeout(() => {
				$scrollholder.addClass('no-scroll');
			}, 200);
		}
	});

	$back.on('click', function() {
		$(this).closest('.active').removeClass('active');

		if($(this).closest('.toggle-wrap').find('.custom-toggle')){
			$(this).closest('.toggle-wrap').find('.custom-toggle').attr('aria-expanded', 'false');
		}

		$scrollholder.removeClass('no-scroll');
	});

	$('#navigationModal').on('hide.bs.modal', function() {
		$(this).find('.active').removeClass('active');
		
		$scrollholder.removeClass('no-scroll');
	});

	$('.navigation > ul > .has-dropdown > a').on('click', function(event) {
		if ( hasTouch() ) {
			const $parent = $(this).parent();
			
			if ( !$parent.hasClass('clicked') ) {
				$parent
					.addClass('clicked')
				.siblings()
					.removeClass('clicked');

				event.preventDefault();
			}
		}
	})
	.on('focusout', function() {
		$(this).parent().removeClass('clicked')
	});
}

function hasTouch() {
	return 'ontouchstart' in document.documentElement
			 || navigator.maxTouchPoints > 0
			 || navigator.msMaxTouchPoints > 0;
}

export default function navsUI() {
	handleNavigationDropdown();
}


// show navigation menu in new header
$(document).ready(function() {
  var $header = $('.header_new'); 
  var $navItems = $('.menu_item'); 

 
  $header.toggleClass('show-nav-trigger', $navItems.length > 6);
});

